import * as Sentry from '@sentry/react';
export const EventCategory = {
    Ui: 'UI',
    Backend: 'Backend',
    CDN: 'Cdn'
};
export const Log = (breadCrumb) => {
    if (!Object.values(breadCrumb).length) {
        return;
    }
    if (process.env.NODE_ENV === 'development') {
        console.log('SENTRY_EVENT_SEND');
        console.log(breadCrumb);
    }
    Sentry.addBreadcrumb(breadCrumb);
};
